import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const Dashboard = Loadable(
	lazy(() =>
		import("./Dashboard/Dashbaord").then(({ Dashboard }) => ({
			default: Dashboard,
		}))
	)
);

export const dashboardRoutes = [
	{
		path: "/dashbaord",
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[]}
				allowFullAccess
			>
				<Dashboard />
			</AuthorizedRoute>
		),
	},
];
